module.exports = __webpack_public_path__ + "img/erweima_wx_mini.ade5293f.jpg";